export default "__VITE_ASSET__CXCm6T87__"